import { Box, useThemeName } from 'braid-design-system';
import type React from 'react';

interface PaymentBoxProps {
  children: React.ReactNode;
  data: Record<string, string>;
}

export const PaymentBox = ({ children, data }: PaymentBoxProps) => {
  // todo: remove after NVL
  const theme = useThemeName();
  return (
    <>
      <Box
        boxShadow="borderNeutralLight"
        padding="gutter"
        borderRadius={theme === 'apac' ? 'standard' : 'xlarge'}
        data={data}
      >
        <>{children}</>
      </Box>
    </>
  );
};
